import React, { ReactElement } from "react";
import { Draggable } from "@hello-pangea/dnd";

interface KanbanCardProps {
	id: string;
	index: number;
	children: React.ReactNode;
}

export const KanbanCard = ({
	id,
	index,
	children,
}: KanbanCardProps): ReactElement => {
	return (
		<Draggable draggableId={id} index={index}>
			{(provided, snapshot) => (
				<div
					ref={provided.innerRef}
					{...provided.draggableProps}
					{...provided.dragHandleProps}
					className={`kanban-card ${snapshot.isDragging ? "dragging" : ""}`}
				>
					{children}
				</div>
			)}
		</Draggable>
	);
};
